/**
 *
 * @param listAttributes
 * @returns {Array}
 */
export function changeAttributesSurvey(listAttributes, typeData) {
  const newList = [] // For all destination support array as a data
  let ph_newList = "" // For Plan Hat because only support text and number
  let name = ""
  let contador = 0
  listAttributes.map((attribute) => {
    contador++
    switch (attribute) {
      case "title":
        name = "Titulo"
        break
      case "description":
        name = ""
        break
      case "message_start":
        name = "Mensaje de bienvenida"
        break
      case "message_end":
        name = "Mensaje Final"
        break
      case "button_start_text":
        name = "Boton de inicio"
        break
      case "button_end_text":
        name = "Boton final"
        break
      case "background_image":
        name = "Imagen de Fondo"
        break
      case "background_image_opacity":
        name = ""
        break
      case "background_color":
        name = "Color de Fondo"
        break
      case "company_logo":
      case "logo_image":
        name = "Logo"
        break
      case "company_logo_opacity":
        name = ""
        break
      case "color_text_question":
        name = "Color texto preguntas"
        break
      case "color_text_likert":
        name = "Color numeración escala Likert"
        break
      case "color_button":
        name = "Color de botones y título"
        break
      case "display_number":
        name = "Numeración preguntas"
        break
      case "display_progress_bar":
        name = "Barra de progreso"
        break
      case "order_random":
        name = "Orden aleatorio de preguntas"
        break
      case "qualitative_icon_image":
        name = ""
        break
      case "enps_icon_image":
        name = ""
        break
      case "box_background_image":
        name = ""
        break
      case "box_company_logo":
        name = ""
        break
      case "likert_text_left":
        name = "Texto extremo izquierdo"
        break
      case "likert_text_center":
        name = "Texto centro"
        break
      case "likert_text_right":
        name = "Texto extremo derecho"
        break
      default:
        name = ""
    }

    if (name != "") {
      typeData === "normal"
        ? newList.push(name)
        : typeData === "planhat"
        ? contador == listAttributes.length
          ? (ph_newList += name)
          : (ph_newList += `${name},`)
        : null
    }
  })

  return typeData === "normal"
    ? newList
    : typeData === "planhat"
    ? ph_newList
    : ""
}

export function changeAttributesQuestion(listAttributes) {
  const newList = []
  let name = ""
  listAttributes.map((attribute) => {
    switch (attribute) {
      case "dimension":
        name = "Dimension"
        break
      case "description":
        name = "Pregunta"
        break
    }
    name != "" ? newList.push(name) : null
  })

  return newList
}

/**
 *
 * @param listAttributes
 * @param typeData
 * @returns {Array}
 */
export function changeAttributesCollaborator(listAttributes, typeData) {
  const newList = [] // For all destination support array as a data
  let ph_newList = "" // For Plan Hat because only support text and number
  let name = ""
  listAttributes.map((attribute) => {
    switch (attribute) {
      case "first_name":
        name = "Nombres"
        break
      case "last_name":
        name = "Primer Apellido"
        break
      case "second_last_name":
        name = "Segundo Apellido"
        break
      case "document":
        name = "DNI"
        break
      case "date_birth":
        name = "Fecha de nacimiento"
        break
      case "id_gender":
        name = "Genero"
        break
      case "id_division":
        name = "Division"
        break
      case "position_name":
        name = "Puesto"
        break
      case "id_position_level":
        name = "Categoria"
        break
      case "email":
        name = "Email"
        break
      case "date_admission":
        name = "Fecha de ingreso"
        break
      case "id_employee_leader":
        name = "Lider"
        break
      case "location":
        name = "Ubicación geográfica"
        break
      case "phone":
        name = "Telefono"
        break
      case "salary":
        name = "Salario"
        break
      case "id_currency":
        name = "Tipo de moneda"
        break
    }
    if (name != "") {
      typeData === "normal"
        ? newList.push(name)
        : typeData === "planhat"
        ? (ph_newList += `${name},`)
        : null
    }
  })

  return typeData === "normal"
    ? newList
    : typeData === "planhat"
    ? ph_newList
    : ""
}

export function changeAttributesMeasure(listAttributes, typeData) {
  const newList = [] // For all destination support array as a data
  let ph_newList = "" // For Plan Hat because only support text and number
  let name = ""
  listAttributes.map((attribute) => {
    switch (attribute) {
      case "email_subject":
        name = "Asunto del correo"
        break
      case "logo":
        name = "Logo"
        break
      case "image":
        name = "Imagen"
        break
      case "email_text":
        name = "Texto"
        break
      case "email_button_text":
        name = "Boton de inicio"
        break
      case "email_background_button":
        name = "Color boton de inicio"
        break
    }
    if (name != "") {
      typeData === "normal"
        ? newList.push(name)
        : typeData === "planhat"
        ? (ph_newList += `${name},`)
        : null
    }
  })

  return typeData === "normal"
    ? newList
    : typeData === "planhat"
    ? ph_newList
    : ""
}

export function changeAttributesScheduleMeasure(listAttributes, typeData) {
  const newList = [] // For all destination support array as a data
  let ph_newList = "" // For Plan Hat because only support text and number
  let name = ""
  listAttributes.map((attribute) => {
    switch (attribute) {
      case "date_start":
        name = "Fecha de Inicio"
        break
      case "date_end":
        name = "Fecha de Fin"
        break
      case "hourd_send":
        name = "Hora de Envio"
        break
      case "days_resend":
        name = "Reenvios"
        break
    }
    if (name != "") {
      typeData === "normal"
        ? newList.push(name)
        : typeData === "planhat"
        ? (ph_newList += `${name},`)
        : null
    }
  })

  return typeData === "normal"
    ? newList
    : typeData === "planhat"
    ? ph_newList
    : ""
}

export function changeAttributesDaysResend(listAttributes) {
  let ph_newList = "" // For Plan Hat because only support text and number
  let contador = 0

  listAttributes.map((attribute) => {
    contador++
    if (attribute != "")
      listAttributes.length == contador
        ? (ph_newList += attribute)
        : (ph_newList += `${attribute},`)
  })

  return ph_newList
}
